import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowStatusMeta } from './core/interface';
import {
  Partners,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';
import { getProposalWorkflowMeta } from './core/proposal-workflow-meta';

@Pipe({
  name: 'proposalWorkflowMeta',
  standalone: true,
})
export class ProposalWorkflowMetaPipe implements PipeTransform {
  transform(
    status: QuoteWorkflowStatus,
    quoteType: QuoteType,
    partner?: Partners
  ): WorkflowStatusMeta {
    return getProposalWorkflowMeta(status, quoteType, partner);
  }
}
